<template>
  <div class="view-page">
    <title-bar title="API KEYs" />

    <div v-if="!loader" class="api-body">

      <!-- Onboarding -->
      <section class="api-section">
        <div class="api-section__head">
          <h2 class="api-section__title">API Key customer</h2>
          <p class="api-section__desc">Para integración de Onboarding.</p>
        </div>
        <div class="api-section__content">
          <span class="api-key-row__label">Clave</span>
          <div class="api-key-row">
            <div class="api-code-box">
              <span class="api-code-box__text">
                {{ showApiKeyCustomer ? (apiKeys.onboarding || '—') : '••••••••••••••••••••••••••••••' }}
              </span>
              <button v-if="apiKeys.onboarding" class="api-code-box__copy" :class="{ 'is-copied': copiedCustomer }" @click="copyToClipboard(apiKeys.onboarding, 'customer')" :title="copiedCustomer ? 'Copiado' : 'Copiar'">
                <i class="fas fa-check" v-if="copiedCustomer"></i>
                <i class="far fa-copy" v-else></i>
              </button>
            </div>
            <button class="api-btn-toggle" @click="showApiKeyCustomerEvent">
              {{ showApiKeyCustomer ? 'Ocultar' : 'Ver' }}
            </button>
          </div>
        </div>
      </section>

      <!-- Backoffice -->
      <section class="api-section">
        <div class="api-section__head">
          <h2 class="api-section__title">API Key Backoffice</h2>
          <p class="api-section__desc">Para integración en CRMs o sistemas backoffices.</p>
        </div>
        <div class="api-section__content">
          <span class="api-key-row__label">Clave</span>
          <div class="api-key-row">
            <template v-if="apiKeys.backoffice">
              <div class="api-code-box">
                <span class="api-code-box__text">
                  {{ showApiKeyBackOffice ? apiKeys.backoffice : '••••••••••••••••••••••••••••••' }}
                </span>
                <button class="api-code-box__copy" :class="{ 'is-copied': copiedBackoffice }" @click="copyToClipboard(apiKeys.backoffice, 'backoffice')" :title="copiedBackoffice ? 'Copiado' : 'Copiar'">
                  <i class="fas fa-check" v-if="copiedBackoffice"></i>
                  <i class="far fa-copy" v-else></i>
                </button>
              </div>
              <button class="api-btn-toggle" @click="showApiKeyBackOfficeEvent">
                {{ showApiKeyBackOffice ? 'Ocultar' : 'Ver' }}
              </button>
            </template>
            <template v-else>
              <span class="api-key-row__empty">Sin clave generada</span>
              <button class="button is-intelligential" @click="isModalOpen = true">
                <span class="icon is-small"><i class="fas fa-plus"></i></span>
                <span>Crear API Key</span>
              </button>
            </template>
          </div>
        </div>
      </section>

    </div>

    <modal-component
      :active="isModalOpen"
      @cancel="isModalOpen = false"
      :titleModal="'Crear API Key'"
      @hdlOnClick="generateApiKey"
      :loading="isLoading"
      :loader="isLoading"
      :textSave="'Continuar'"
    >
      <div class="api-key-confirm">
        <div class="api-key-confirm__icon-wrap">
          <i class="fas fa-key api-key-confirm__icon"></i>
        </div>
        <p class="api-key-confirm__text">
          Se generará una nueva API Key. Esta clave no podrá ser editada posteriormente y estará visible únicamente desde este módulo.
        </p>
        <div class="api-key-confirm__notice">
          <i class="fas fa-exclamation-triangle api-key-confirm__notice-icon"></i>
          <span>Esta acción no se puede deshacer. Guarda tu clave en un lugar seguro.</span>
        </div>
      </div>
    </modal-component>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '../../mixins/formats'
export default {
  components: {
    TitleBar: () => import('@/components/ui/TitleBar.vue'),
    ModalComponent: () => import('@/components/ui/ModalComponent')
  },
  mixins: [mixins],
  data () {
    return {
      loading: true,
      apiKeys: {},
      showApiKeyCustomer: false,
      showApiKeyBackOffice: false,
      copiedCustomer: false,
      copiedBackoffice: false,
      isLoading: false,
      isModalOpen: false,
      loader: false
    }
  },
  methods: {
    ...mapActions(['getApiKeys', 'createApiKey']),
    showApiKeyCustomerEvent () {
      this.showApiKeyCustomer = !this.showApiKeyCustomer
    },
    showApiKeyBackOfficeEvent () {
      this.showApiKeyBackOffice = !this.showApiKeyBackOffice
    },
    async copyToClipboard (text, target) {
      try {
        await navigator.clipboard.writeText(text)
        if (target === 'customer') {
          this.copiedCustomer = true
          setTimeout(() => { this.copiedCustomer = false }, 2000)
        } else {
          this.copiedBackoffice = true
          setTimeout(() => { this.copiedBackoffice = false }, 2000)
        }
      } catch (e) {}
    },
    async generateApiKey () {
      this.isLoading = true
      const response = await this.createApiKey()
      if (response) {
        const apiKeys = await this.getApiKeys()
        this.apiKeys = apiKeys
        this.showApiKeyBackOffice = true
      }
      this.isLoading = false
      this.isModalOpen = false
    },
    async loadApiKeys () {
      this.loader = true
      const apiKeys = await this.getApiKeys()
      this.apiKeys = apiKeys
      this.loader = false
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      profile: (state) => state.financialCompany.financialCompany
    })
  },
  mounted () {
    this.loadApiKeys()
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
.api-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.api-section {
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 1.5rem;
  background: #ffffff;
  border: 1px solid #eef0f3;
  border-radius: 12px;
  padding: 1.75rem 2rem;
}

.api-section__head {
  padding-right: 1rem;
  border-right: 1px solid #eef0f3;
}

.api-section__title {
  font-size: 14px;
  font-weight: 600;
  color: #1a2233;
  margin: 0 0 6px;
}

.api-section__desc {
  font-size: 12px;
  color: #9aa5b4;
  line-height: 1.5;
  margin: 0;
}

.api-section__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.api-key-row__label {
  display: block;
  font-size: 11px;
  font-weight: 500;
  color: #9aa5b4;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 8px;
}

.api-key-row {
  display: flex;
  align-items: center;
  gap: 10px;

  &__empty {
    font-size: 13px;
    color: #c0c8d4;
    font-style: italic;
    flex: 1;
  }
}

.api-code-box {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  background: #f4f5f7;
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  padding: 0 4px 0 14px;
  height: 40px;
  gap: 8px;

  &__text {
    flex: 1;
    min-width: 0;
    font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
    font-size: 12.5px;
    color: #2d3748;
    letter-spacing: 0.4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__copy {
    flex-shrink: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    color: #9aa5b4;
    font-size: 13px;
    transition: background 0.15s, color 0.15s;

    &:hover {
      background: #e4e7ec;
      color: #2d3748;
    }

    &.is-copied {
      color: #27ae60;
      &:hover { background: #eafaf1; }
    }
  }
}

.api-btn-toggle {
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: $blue;
  background: none;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  padding: 5px 10px;
  border-radius: 6px;
  flex-shrink: 0;
  transition: background 0.15s;

  &:hover {
    background: #edf1ff;
  }
}

// Modal body
.api-key-confirm {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 0 4px;
  gap: 16px;

  &__icon-wrap {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #edf1ff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  &__icon {
    font-size: 22px;
    color: #4c70ff;
    transform: rotate(-45deg);
  }

  &__text {
    font-size: 13px;
    font-weight: 500;
    color: #484c53;
    text-align: center;
    line-height: 1.6;
    margin: 0;
    max-width: 340px;
  }

  &__notice {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    background: #fffbec;
    border: 1px solid #ffe58f;
    border-radius: 8px;
    padding: 10px 14px;
    width: 100%;
    font-size: 12px;
    font-weight: 500;
    color: #7a5c00;
    line-height: 1.5;
  }

  &__notice-icon {
    color: #f0a500;
    font-size: 13px;
    margin-top: 1px;
    flex-shrink: 0;
  }
}
</style>
